import useEnv from '../composables/useEnv'
import useRestNode from '../composables/useRestNode'
import useCareConcepts from '../composables/useCareConcepts'

export default () => {


    const { apiLingo2Endpoint } = useEnv()
    const { get } = useRestNode()
    const { careConceptsToCpnIds } = useCareConcepts()

    /**
     * This function will call api-lingo2 to execute a semantic search against careConcepts and procedures.
     * It should return a list of careConcepts suitable for submitting to CPN for search as well as displaying 
     * in the careConcept filter.  It will also contain a list of procedures suitable
     * for displaying in the procedures filter.  It will also contain the betterChoiceContext if it is able 
     * to be resolved.  If the betterChoiceContext is not able to be resolved, it will be represented as an
     * empty string.  The payload will look like the following:
     * 
     * NOTE: CareConcepts will be returned in the context of the network.  Only careConcepts that are valid
     * for th network will be returned by api-lingo2.  Therefore, there is no need to execute a filtering
     * step later.
     * 
     * {
     *  careConcepts: []
     *  procedures: [],
     *  betterChoiceContext: ""
     * }
     * 
     *  The function accepts two parameters
     *  question - The question asked of the search.
     *  serviceType - Either 'practitioner' or 'location'
     *  healthLineCode - The 'code' returned in the context from the UI.
     *  convertedForCpn - Determines whether careConcepts should be converted for CPN ( i.e psp202 ).  Defaults to false.
     *  fromFilters - The careConcepts that were selected on the UI and stored in context.
     */
    const search = async (question, networkId, options = {}) => {

        //The following are the possible options in the options parameter.  If any are missing they will be considered undefined.
        const { serviceType, practiceType, type, healthLineCode, convertForCpn = false, fromFilters } = options;

        try {
            if ( !question ) return { careConcepts: [], procedures: [], betterChoiceContext: ''}

            const url = new URL(`${apiLingo2Endpoint}/search`)
            url.searchParams.append('networkId', networkId)
            url.searchParams.append('question', question)
            url.searchParams.append('maxResults', 5)
            if ( serviceType ) url.searchParams.append('serviceType', serviceType)
            //if ( practiceType ) url.searchParams.append("practiceType", practiceType)
            if ( type ) url.searchParams.append("type", type)

            console.log("Lingo2 url to request", url.toString())

            const result = await get(url.toString())
            //console.log("Lingo2 result", result)
            const { careConcepts, procedures } = result.value
            const betterChoiceContext = deriveBetterChoiceContext(healthLineCode, procedures)

            let conceptsToReturn

            //If the careConcepts were supplied via the cc parameter in the request ( as a result of filters ), then return them directly
            //Otherwise return lingo2 provided careConcepts.
            if ( fromFilters && fromFilters.length > 0 ) conceptsToReturn = fromFilters
            else conceptsToReturn = convertForCpn ? careConceptsToCpnIds(careConcepts) : careConcepts

            return { careConcepts: conceptsToReturn, procedures, betterChoiceContext, rawConcepts: careConcepts }
        }
        catch(error) {
            console.log(error)
            throw new Error(error.message)
        }
    }

    /**
     * Derive the better choice context from the procedures returned from Lingo and from the healthLineCode
     * if it was provided by the application ( A user selected a procedure in the procedure filter )
     */
    const deriveBetterChoiceContext = (healthLineCode, procedures) => {
        if ( healthLineCode && procedures ) {
            const procedure = procedures.find(p => p.healthLineCode == healthLineCode)
            return procedure && procedure.healthLineCode ? procedure.betterChoiceContext : ''
        }
        
        if ( procedures && procedures.length == 1 ) {
            return procedures[0].betterChoiceContext ? procedures[0].betterChoiceContext : ''
        }

        return ''
    }

    return { search, deriveBetterChoiceContext }

}